
import { DollarSign, Zap, QrCode, Timer } from "lucide-react";
import { Button } from "@/components/ui/button";

export const BenefitsSection = () => {
  const benefits = [
    {
      icon: DollarSign,
      title: "No More Expensive Ticketing Fees",
      description: "Keep more revenue from every sale with our industry-leading low fees"
    },
    {
      icon: Zap,
      title: "AI-Powered Marketing",
      description: "Reach partygoers most likely to attend your events"
    },
    {
      icon: QrCode,
      title: "Seamless QR Code Ticketing",
      description: "Easy check-in at any venue with instant verification"
    },
    {
      icon: Timer,
      title: "Instant Payouts",
      description: "Get paid faster for ticket sales with rapid transfers"
    }
  ];

  return (
    <div className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-4">
          Why Choose ClubMate for Promotions?
        </h2>
        <p className="text-xl text-gray-400 text-center mb-16 max-w-2xl mx-auto">
          The smartest way to promote and sell tickets to your events
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="p-6 rounded-xl bg-gray-900 border-2 border-purple-500/30 shadow-[0_0_30px_rgba(168,85,247,0.15)] hover:shadow-[0_0_30px_rgba(168,85,247,0.25)] transition-all duration-300"
            >
              <benefit.icon className="w-12 h-12 text-purple-400 mb-4" />
              <h3 className="text-xl font-semibold text-white mb-2">{benefit.title}</h3>
              <p className="text-gray-400">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button
            size="lg"
            className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white rounded-full px-8 shadow-[0_0_30px_rgba(168,85,247,0.4)] hover:shadow-[0_0_30px_rgba(168,85,247,0.6)] transition-all duration-300"
          >
            Start Promoting – List Your First Event Now
          </Button>
        </div>
      </div>
    </div>
  );
};
